<script>
  /**
   * ケバブメニュー
   *  Bulma Dropdown https://bulma.io/documentation/components/dropdown/
   */
  import { createEventDispatcher } from 'svelte'

  export let name
  export let isActive = false

  const dispatch = createEventDispatcher()

  // メニュー アイテムを選択された時にイベントをディスパッチ
  const select = (name) => {
    isActive = false // メニューを隠す
    dispatch('select', { name })
  }

  // メニュー アイテム配列
  //  将来的にはこれをexportすれば汎用的に使える
  const items = [
    { name: 'edit', label: '編集', icon: 'edit' },
    { name: 'copy', label: 'コピー', icon: 'copy' },
    { name: 'bottom', label: '一番下へ', icon: 'angle-double-down' },
    {},
    { name: 'delete', label: '削除', icon: 'trash-alt' },
  ]
</script>

<div
  class="dropdown is-right"
  class:is-active={isActive}
  data-testid={`${name}KebabMenu`}
>
  <!-- トグル ボタン -->
  <div class="dropdown-trigger">
    <button
      class="button"
      data-testid={`${name}KebabToggle`}
      aria-haspopup="true"
      aria-controls="dropdown-menu"
      on:click={() => (isActive = !isActive)}
    >
      <span class="icon">
        <i class="fas fa-ellipsis-v" aria-hidden="true" />
      </span>
    </button>
  </div>

  <!-- メニュー -->
  <div class="dropdown-menu" id="dropdown-menu" role="menu">
    <div class="dropdown-content">
      {#each items as item, index}
        <div data-testid={`${name}Item${index}`}>
          {#if item.label}
            <button
              class="dropdown-item button"
              data-testid={`${name}Button-${item.name}`}
              on:click={() => select(item.name)}
            >
              <span class="icon">
                <i class={`fas fa-${item.icon}`} aria-hidden="true" />
              </span><span>{item.label}</span>
            </button>
          {:else}
            <hr class="dropdown-divider" />
          {/if}
        </div>
      {/each}
    </div>
  </div>
</div>

<style>
  /* ボタンを枠なしにする */
  button {
    border: none;
    background: none;
  }

  /* 右寄せして上に重ねる */
  .dropdown {
    position: absolute;
    width: 3.25rem;
    height: 3.25rem;
    right: 0rem;
    top: 0.5rem;
  }

  /* メニューの幅を狭めにする */
  .dropdown-menu {
    min-width: 2rem;
  }
</style>
